// @flow

import { serialize } from 'object-to-formdata';
import { hpfetch, hpXHR } from '../util';

export const submit = (
  name: string,
  email: string,
  video: File,
  onProgress: ProgressEvent => void,
) => {
  return hpfetch('contest-submissions/', {
    method: 'POST',
    body: JSON.stringify({
      name,
      email,
      filename: video.name,
    }),
  }).then(res => {
    const { fields, url } = res.body.presigned_url;
    const form = serialize(fields);
    form.append('file', video);

    return hpXHR(url, 'POST', form, onProgress);
  });
};
